// Core lib dependencies.
import React from 'react';
import PropTypes from 'prop-types';

// Shared utils for Display Items.
import * as utils from './utils.jsx';

import _ from 'lodash';

import { ItemCTA } from './items/item-components';

/**
 * <pre>
 * Display Item > Document related React components.
 *
 * </pre>
 *
 * @author Various
 * @namespace Common.Components.DisplayItems.Document
 */

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
/* Components */

/**
 * Header.
 *
 * @namespace
 * @memberOf Common.Components.DisplayItems.Document
 */
class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const item = this.props.item;
    const assetUrl = _.get(this, 'context.config.assetUrl') || this.props.assetUrl;
    const assetUgcUrl = _.get(this, 'context.config.assetUgcUrl') || this.props.assetUgcUrl;
    const itemAsset = utils.getItemAsset({ item, assetUrl, assetUgcUrl });
    const mainContent = utils.getItemContent({ item, type: 'main' });
    return (
      <div
        onClick={this.props.onClick}
        className={utils.getClassNamesForItem({ item, templateOpts: { itemTemplate: 'header' } })}
      >
        <div className="xItemInner">
          {itemAsset}
          <If condition={!!mainContent}>
            <div className="xBodyContainer">
              {mainContent}
              {this.props.children}
              {/*  cta content belongs inside body container */}
              <If condition={!!item.content.link && !!item.content.linkText}>
                <ItemCTA href={item.content.link} target="_blank" linkText={item.content.linkText} />
              </If>
            </div>
          </If>
        </div>
      </div>
    );
  }
}

Header.contextTypes = {
  config:      PropTypes.object,
  assetUrl:    PropTypes.string,
  assetUgcUrl: PropTypes.string,
};

export { Header };

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
/* Private utility functions */
